<template>
  <div data-component-group="threads-form" data-component="comments">
    <div class="component-header">
      <h2>
        {{ commentsTitle }}
      </h2>
      <v-autocomplete
        v-model="commentFilter"
        :items="commentFilters"
        label="Show comments from"
        item-title="label"
        item-value="action"
        :return-object="true"
        :hide-details="true"
        required
        :loading="isLoading"
        prepend-inner-icon="visibility"
        @update:model-value="onSubmit"
      />
    </div>

    <CommentsList
      v-if="hasComments"
      :comments="comments"
      :is-loading="isLoading"
    />
  </div>
</template>

<script>
  import CommentsList from '../../lists/Comments';
  import commentFilters from '../../../config/threads/commentFilters';

  // TODO: Translate component

  export default {
    components: {
      CommentsList,
    },
    props: {
      comments: {
        type: Array,
        default() {
          return [];
        },
      },
      triggerLabel: {
        type: String,
        default: 'Post comment',
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      onSubmit: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        commentFilter: null,
        commentFilters,
      };
    },
    computed: {
      commentsTitle() {
        return `${this.comments.length} Comments`;
      },
      hasComments() {
        return this.comments.length > 0;
      },
    },
    created() {
      const [firstCommentFilter] = this.commentFilters;
      this.commentFilter = firstCommentFilter;
    },
    methods: {
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='threads-form'][data-component='comments'] {
  padding: 32px 0 0 0;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);

  [data-component='removables'] {
    .v-list {
      padding: 0;
      margin: -4px 0 0 0;
    }
  }

  [data-component-group='list'][data-component='comments'] {
    padding: 20px 0 0 0;
  }

  .component-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0 16px 0;

    h2 {
      min-width: 60%;
      line-height: 24px;
      letter-spacing: 0.4px;
    }
  }

  .label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: $text-size-sm;
    padding: 2px 6px;
    margin: 0 10px 10px 0;
    border-radius: $border-radius;
    color: map.get($colors, shades, 'white');
    background-color: map.get($colors, primary);

    .v-icon {
      font-size: $text-size-md;
      margin: 0 6px 0 0;
      color: map.get($colors, shades, 'white');
    }
  }

  .v-input {
    .v-select__selection {
      color: map.get($colors, shades, 'white');
      background-color: map.get($colors, primary);
      border-radius: $border-radius;
      padding: 5px;
    }

    &.v-input--is-disabled {
      .v-select__selection {
        color: map.get($colors, shades, 'white');
        background-color: map.get($colors, grey, base);
        border-radius: $border-radius;
        padding: 5px;
      }
    }
  }
}
</style>
